import React from 'react';
import { View, StyleSheet } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../../constants';
import ParkingDetailViewCommon from './ParkingDetailViewCommon';

/**
 * ParkingDetailsViewWeb Component
 * 
 * This component renders the details of a parking specifically for a web environment.
 * It displays the parking type, number of free spaces and location of a parking, making use of the DetailCommon component for the UI.
 * 
 * Props:
 *  - route: Contains parameters passed through the navigation stack, including the parking details.
 * 
 * @file ParkingDetailsViewWeb.js
 * @module ParkingDetailsViewWeb
 */
const ParkingDetailsViewWeb = ({ route }) => {
    return (
        <View style={styles.container}>
            <ParkingDetailViewCommon
                route={route}
                FontAwesomeIcon={FontAwesomeIcon}
                iconSize='lg'
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.textLight,
        padding: 16,
    },
});

export default ParkingDetailsViewWeb;
